import {
    PRODUCTION_DETAIL_YARN_REPORT_REQUEST,
    PRODUCTION_DETAIL_YARN_REPORT_SUCCESS,
    PRODUCTION_DETAIL_YARN_REPORT_FAILURE,
    PRODUCTION_DETAIL_YARN_FILTER_REPORT_REQUEST,
    PRODUCTION_DETAIL_YARN_FILTER_REPORT_SUCCESS,
    PRODUCTION_DETAIL_YARN_FILTER_REPORT_FAILURE
  } from "../types/production-detail-yarn-report-types";
  
const initialState = {
    productionDetailYarnReport: {},
    productionDetailYarnFilterOptions: {},
    loading: false,
    error: null,
};

const productionDetailYarnReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case PRODUCTION_DETAIL_YARN_REPORT_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null,
                productionDetailYarnReport: {}
            };
        }
        case PRODUCTION_DETAIL_YARN_FILTER_REPORT_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            };
        }
        case PRODUCTION_DETAIL_YARN_REPORT_SUCCESS: {
            return {
                ...state,
                productionDetailYarnReport: {...(action.payload || {})},
                loading: false,
                error: null
            };
        }
         case PRODUCTION_DETAIL_YARN_FILTER_REPORT_SUCCESS: {
            return {
                ...state,
                productionDetailYarnFilterOptions: {...(action.payload || {})},
                loading: false,
                error: null
            };
        }
        case PRODUCTION_DETAIL_YARN_REPORT_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.error
            };
        }
         case PRODUCTION_DETAIL_YARN_FILTER_REPORT_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.error
            };
        }
        default:
        return state;
    }
};

export default productionDetailYarnReportReducer;